import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '../../../../entry-routes/configuration/configuration.service';
import { TaskFormAction } from '../action/task-form.action';
import { TaskForm } from '../../../models/task-form';
import { TaskFormValue, TaskFormValueType } from '../../../models/task-form-value';
import { TaskFormField } from '../../../models/task-form-field';
import { WkfTaskService } from '../../../services/workflow/wkf-task-service';
import { AuthenticationService } from '../../../../entry-routes/authentication/authentication.service';
import { Utils } from '../../../utils/utils';
import { Url } from '../../../models/url';
import { Store } from '@ngrx/store';
import { selectTaskFormDatas } from '../task-form-selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TaskFormService {
  private taskFormData$= this.store.select(selectTaskFormDatas).pipe(takeUntilDestroyed());
  private taskForm: TaskForm;

  constructor(
    private taskFormAction: TaskFormAction,
    private httpClient: HttpClient,
    private configAction: ConfigurationService,
    private wkfTaskService: WkfTaskService,
    protected authenticationService: AuthenticationService,
    private store: Store,
    private translateService: TranslateService
  ) {
    this.taskFormData$.subscribe( (taskFormData:TaskForm) => {this.taskForm = taskFormData})
  }

  /*
  private mergeTaskFormWithTaskValues(taskForm: TaskForm, taskFormValues: {[key: string]: TaskFormValue}): TaskForm {
    taskForm.components.forEach((taskFormField: TaskFormField) => {
      const taskFormValue: TaskFormValue = taskFormValues[taskFormField.id];
      if (!!taskFormValue) {
        switch (taskFormValue.type) {
          case TaskFormValueType.STRING:
          case TaskFormValueType.INTEGER:
          case TaskFormValueType.BOOLEAN:
          case TaskFormValueType.OBJECT:
            taskFormField.value = taskFormValue.value;
            break;
        }
      } else {
        switch (taskFormField.type) {
          case TaskFormFieldType.TEXTFIELD:
          case TaskFormFieldType.NUMBER:
          case TaskFormFieldType.SELECT:
            taskFormField.value = taskFormField.defaultValue ? taskFormField.defaultValue : null;
            break;
          case TaskFormFieldType.CHECKBOX:
            taskFormField.value = taskFormField.defaultValue ? taskFormField.defaultValue : false;
            break;
        }
      }
    });
    return taskForm;
  }
*/
  public getTaskForm(taskId: string): void {
    try {
      this.taskFormAction.loadTaskFormStart();
      /*const taskFormRequest$: Observable<any> = this.httpClient.get<any>(
        //Url.getCamundaProtectedApiBaseUrl(this.configAction)  + '/' + Url.RUNTIME_TASKS + taskId + '/form'
        '/flowable-ui/app/rest/task-forms/'+taskId, this.httpOptions
      );*/

      const taskFormRequest$ :Observable<any> = this.wkfTaskService.getTaskForm(taskId);

     /*
      // const taskFormRequest$: Observable<TaskForm> = this.httpClient.get<TaskForm>(this.getTaskFormMockUrl());
      /*const taskFormValuesRequest$: Observable<{[key: string]: TaskFormValue}> = this.httpClient.get<{[key: string]: TaskFormValue}>(
        Url.getCamundaProtectedApiBaseUrl(this.configAction) + Url.TASK + taskId + '/' + Url.FORM_VARIABLES
      );*/

      const taskFormValue1 = new TaskFormValue();
      taskFormValue1.type=TaskFormValueType.STRING;
      taskFormValue1.value="Nom";

      const taskFormValuesRequest$: Observable<{[key: string]: TaskFormValue}> =of({'label':taskFormValue1});
      // const taskFormValuesRequest$: Observable<{[key: string]: TaskFormValue}> = this.httpClient.get<{[key: string]: TaskFormValue}>(this.getTaskFormValuesMockUrl());

      forkJoin([taskFormRequest$, taskFormValuesRequest$])
        .subscribe(([taskForm, taskFormValues]: [TaskForm, {[key: string]: TaskFormValue}]) => {
          console.debug('taskForm',taskForm);
          console.debug('taskFormValues',taskFormValues);
          //this.taskFormAction.loadTaskFormSucceeded(this.mergeTaskFormWithTaskValues(taskForm, taskFormValues));
         this.taskFormAction.loadTaskFormSucceeded(taskForm);
      },
          (error: HttpErrorResponse) =>
          this.taskFormAction.loadTaskFormFailed(error)
          );
    } catch (err) {
      console.error('error', err);
      this.taskFormAction.loadTaskFormFailed(err);
    }
  }

  getProcessLastForm(processId: string) {
    try {
      this.taskFormAction.loadTaskFormStart();

      const chunkHeaders = Utils.objectTokenHeader(this.authenticationService.getApplicationTokenFromSessionStorage());
      const urlProcessLastForm = Url.getFlowableProtectedApiBaseUrl(this.configAction)+Url.WKF_NEXIA_API+'/'+Url.WKF_PROCESS + processId + Url.WKF_FORM

      const processLastFormRequest$ = this.httpClient.get<TaskForm>(urlProcessLastForm, {headers: chunkHeaders});

      processLastFormRequest$
        .subscribe( {
          next: ( processLastTaskForm: TaskForm ) => {
            console.debug( 'taskForm', processLastTaskForm );
            //this.taskFormAction.loadTaskFormSucceeded(this.mergeTaskFormWithTaskValues(taskForm, taskFormValues));
            this.taskFormAction.loadTaskFormSucceeded( processLastTaskForm );
          },
          error: (error)  =>  {
            this.taskFormAction.loadTaskFormFailed( error );
          }
        });
    } catch (err) {
      console.error('error', err);
      this.taskFormAction.loadTaskFormFailed(err);
    }
  }

  public updateTaskFormInStore(taskForm : TaskForm) {
    this.taskFormAction.loadTaskFormStart();
    try {
      this.taskFormAction.loadTaskFormSucceeded(taskForm);
    }
    catch (error) {
      this.taskFormAction.loadTaskFormFailed(error);
    }
  }

  public updateTaskFormFieldInStore(taskFormField : TaskFormField) {
    this.taskFormAction.updateTaskFormFieldStart();
    try {
      this.taskFormAction.updateTaskFormFieldSucceed(taskFormField);
    }
    catch (error) {
      this.taskFormAction.updateTaskFormFieldFailed(error);
    }
  }
  public getTaskFormField(taskFormFieldId: string) : TaskFormField {
    return this.taskForm.fields.find( (field) => field.id === taskFormFieldId);
  }

  public getTaskFormFieldFromHistoryEventKey( key: string ) : TaskFormField {
    let  taskFormFieldKey = key;

    // cdx_datas.XXX recu dans le diff
    if ( taskFormFieldKey.indexOf('cdx_datas.')===0) {
      taskFormFieldKey = key.replace('cdx_datas.','cdx_datas_');
    }
    if ( (taskFormFieldKey.indexOf('cdx_links.') === 0) && (taskFormFieldKey.endsWith('.0.cdx_title'))) {
      taskFormFieldKey = key.replace('cdx_links.','cdx_links_').replace('.0.cdx_title','');
    }
    if ( (taskFormFieldKey.indexOf('cdx_wkf.cdx_datas.') === 0) && ( ( taskFormFieldKey.endsWith('.0') || taskFormFieldKey.endsWith('.0.i18n.fr') || taskFormFieldKey.endsWith('.0.item.value') ) )) {
      taskFormFieldKey = key.replace('cdx_wkf.cdx_datas.','')
                            .replace('.0','')
                            .replace('.i18n.fr','')
                            .replace('.item.value','');
    }
    // cas de la création (onlyNew), on a pas de cdx_datas_ , dans la clé récupérée, hors pour le trouver dans taskform, il le faut !
    if ( taskFormFieldKey.indexOf('cdx_datas_')===-1 && key.indexOf('cdx_links.')===-1 && key.indexOf('cdx_wkf.cdx_datas.')===-1 )
    {
      taskFormFieldKey = 'cdx_datas_'+taskFormFieldKey;
    }

    if(taskFormFieldKey.endsWith('.i18n.'+this.translateService.currentLang)) {
      taskFormFieldKey = taskFormFieldKey.replace('.i18n.'+this.translateService.currentLang,'');
    }
    console.debug('Recherche dans taskForm le champ avec id : ',taskFormFieldKey)
    const taskFormField: TaskFormField = this.getTaskFormField(taskFormFieldKey);
    return taskFormField;
  }
}
